import isArray from 'lodash/isArray';

export function isNodeTogglePanel(node) {
  return node && node.childrenCount && (node.type === 'database' || node.type === 'section');
}

// eslint-disable-next-line import/prefer-default-export
export function nodesCollector(nodes) {
  return nodes.reduce((acc, node, i) => {
    const _node = { ...node };

    if (isArray(_node.children)) {
      _node.children = nodesCollector(_node.children);
    }

    if (isNodeTogglePanel(_node)) {
      if (isNodeTogglePanel(nodes[i - 1])) {
        acc[acc.length - 1].push(_node);
      } else {
        acc.push([_node]);
      }
    } else {
      acc.push(_node);
    }

    return acc;
  }, []);
}
